export default {
  sendSystemMessage,
  getSystemMessages,
  getSystemMessagesByClientId,
  deleteSystemMessageById,
  markSystemMessageAsRead,
};

import api from '@/shared/api.service';

async function sendSystemMessage(subject, content) {
  return await api.post('/api/system-message', { subject, content });
}

async function getSystemMessages() {
  return await api.get('/api/system-message');
}

async function getSystemMessagesByClientId(id) {
  return await api.get(`/api/system-message/${id}`);
}

async function deleteSystemMessageById(id) {
  return await api.delete('/api/system-message', {
    params: { id },
  });
}

async function markSystemMessageAsRead(data) {
  return await api.post('/api/system-message/mark-as-read', data );
}
